// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__OYCxE","titleIcon":"style_titleIcon__16ZMc","inputSection":"style_inputSection__2ebJN","secondsPerValveInput":"style_secondsPerValveInput__22RXc"};